// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AddBlockController from "./add_block_controller";
application.register("add-block", AddBlockController);

import AdminCompanyController from "./admin_company_controller";
application.register("admin-company", AdminCompanyController);

import AppGroupsController from "./app_groups_controller";
application.register("app-groups", AppGroupsController);

import AppsController from "./apps_controller";
application.register("apps", AppsController);

import BoardController from "./board_controller";
application.register("board", BoardController);

import BoardExportController from "./board_export_controller";
application.register("board-export", BoardExportController);

import BoardLabelsController from "./board_labels_controller";
application.register("board-labels", BoardLabelsController);

import BoardMoveController from "./board_move_controller";
application.register("board-move", BoardMoveController);

import BoardPermissionsController from "./board_permissions_controller";
application.register("board-permissions", BoardPermissionsController);

import BoardThumbController from "./board_thumb_controller";
application.register("board-thumb", BoardThumbController);

import BoardTransferController from "./board_transfer_controller";
application.register("board-transfer", BoardTransferController);

import BoardTrashController from "./board_trash_controller";
application.register("board-trash", BoardTrashController);

import BoardsController from "./boards_controller";
application.register("boards", BoardsController);

import BsModalController from "./bs_modal_controller";
application.register("bs-modal", BsModalController);

import BsModalFormController from "./bs_modal_form_controller";
application.register("bs-modal-form", BsModalFormController);

import BudgetController from "./budget_controller";
application.register("budget", BudgetController);

import ChangeViewController from "./change_view_controller";
application.register("change-view", ChangeViewController);

import CheckboxesController from "./checkboxes_controller";
application.register("checkboxes", CheckboxesController);

import ChromeExtensionCheckController from "./chrome_extension_check_controller";
application.register("chrome-extension-check", ChromeExtensionCheckController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import ColorDropdownController from "./color_dropdown_controller";
application.register("color-dropdown", ColorDropdownController);

import ColorPickerController from "./color_picker_controller";
application.register("color-picker", ColorPickerController);

import CommentController from "./comment_controller";
application.register("comment", CommentController);

import CommentSortableController from "./comment_sortable_controller";
application.register("comment-sortable", CommentSortableController);

import CommentsController from "./comments_controller";
application.register("comments", CommentsController);

import CommentsPanelController from "./comments_panel_controller";
application.register("comments-panel", CommentsPanelController);

import CompanyController from "./company_controller";
application.register("company", CompanyController);

import ConfettiController from "./confetti_controller";
application.register("confetti", ConfettiController);

import ContainerController from "./container_controller";
application.register("container", ContainerController);

import ContainersController from "./containers_controller";
application.register("containers", ContainersController);

import CountryCodeController from "./country_code_controller";
application.register("country-code", CountryCodeController);

import CropperController from "./cropper_controller";
application.register("cropper", CropperController);

import DashboardController from "./dashboard_controller";
application.register("dashboard", DashboardController);

import DemoController from "./demo_controller";
application.register("demo", DemoController);

import DemoExtensionLibraryController from "./demo_extension_library_controller";
application.register("demo-extension-library", DemoExtensionLibraryController);

import DropboxController from "./dropbox_controller";
application.register("dropbox", DropboxController);

import DropdownSelectController from "./dropdown_select_controller";
application.register("dropdown-select", DropdownSelectController);

import DzCommentController from "./dz_comment_controller";
application.register("dz-comment", DzCommentController);

import DzIdeaController from "./dz_idea_controller";
application.register("dz-idea", DzIdeaController);

import DzItemController from "./dz_item_controller";
application.register("dz-item", DzItemController);

import DzProjectController from "./dz_project_controller";
application.register("dz-project", DzProjectController);

import DzProjectsController from "./dz_projects_controller";
application.register("dz-projects", DzProjectsController);

import ErrorHandlerController from "./error_handler_controller";
application.register("error-handler", ErrorHandlerController);

import FieldController from "./field_controller";
application.register("field", FieldController);

import FieldNewController from "./field_new_controller";
application.register("field-new", FieldNewController);

import FinderController from "./finder_controller";
application.register("finder", FinderController);

import FixBackdropController from "./fix_backdrop_controller";
application.register("fix-backdrop", FixBackdropController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import GalleryController from "./gallery_controller";
application.register("gallery", GalleryController);

import GalleryItemsController from "./gallery_items_controller";
application.register("gallery-items", GalleryItemsController);

import GallerySearchController from "./gallery_search_controller";
application.register("gallery-search", GallerySearchController);

import GalleryUploadController from "./gallery_upload_controller";
application.register("gallery-upload", GalleryUploadController);

import GooglePickerController from "./google_picker_controller";
application.register("google-picker", GooglePickerController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import HomeController from "./home_controller";
application.register("home", HomeController);

import IdeaController from "./idea_controller";
application.register("idea", IdeaController);

import IdeaCopyController from "./idea_copy_controller";
application.register("idea-copy", IdeaCopyController);

import InfoPaneController from "./info_pane_controller";
application.register("info-pane", InfoPaneController);

import InlineEditorController from "./inline_editor_controller";
application.register("inline-editor", InlineEditorController);

import ItemController from "./item_controller";
application.register("item", ItemController);

import ItemCopyController from "./item_copy_controller";
application.register("item-copy", ItemCopyController);

import ItemExportController from "./item_export_controller";
application.register("item-export", ItemExportController);

import ItemFieldController from "./item_field_controller";
application.register("item-field", ItemFieldController);

import ItemLabelsController from "./item_labels_controller";
application.register("item-labels", ItemLabelsController);

import ItemMoveController from "./item_move_controller";
application.register("item-move", ItemMoveController);

import ItemPermissionsController from "./item_permissions_controller";
application.register("item-permissions", ItemPermissionsController);

import ItemPresentController from "./item_present_controller";
application.register("item-present", ItemPresentController);

import ItemShareController from "./item_share_controller";
application.register("item-share", ItemShareController);

import ItemVendorController from "./item_vendor_controller";
application.register("item-vendor", ItemVendorController);

import ItemsAddToBoardController from "./items_add_to_board_controller";
application.register("items-add-to-board", ItemsAddToBoardController);

import ItemsAssignLabelsController from "./items_assign_labels_controller";
application.register("items-assign-labels", ItemsAssignLabelsController);

import ItemsController from "./items_controller";
application.register("items", ItemsController);

import LabelsController from "./labels_controller";
application.register("labels", LabelsController);

import ListController from "./list_controller";
application.register("list", ListController);

import LoadMoreController from "./load_more_controller";
application.register("load-more", LoadMoreController);

import LongPressController from "./long_press_controller";
application.register("long-press", LongPressController);

import MemberController from "./member_controller";
application.register("member", MemberController);

import MembersController from "./members_controller";
application.register("members", MembersController);

import MoodboardController from "./moodboard_controller";
application.register("moodboard", MoodboardController);

import NoteController from "./note_controller";
application.register("note", NoteController);

import OffcanvasController from "./offcanvas_controller";
application.register("offcanvas", OffcanvasController);

import PageController from "./page_controller";
application.register("page", PageController);

import PermissionsController from "./permissions_controller";
application.register("permissions", PermissionsController);

import ProgressBarController from "./progress_bar_controller";
application.register("progress-bar", ProgressBarController);

import ProjectController from "./project_controller";
application.register("project", ProjectController);

import ProjectsController from "./projects_controller";
application.register("projects", ProjectsController);

import PublicBoardController from "./public_board_controller";
application.register("public-board", PublicBoardController);

import PublicTileController from "./public_tile_controller";
application.register("public-tile", PublicTileController);

import QuickbooksController from "./quickbooks_controller";
application.register("quickbooks", QuickbooksController);

import RecaptchaV2Controller from "./recaptcha_v2_controller";
application.register("recaptcha-v2", RecaptchaV2Controller);

import SearchController from "./search_controller";
application.register("search", SearchController);

import SearchDropdownController from "./search_dropdown_controller";
application.register("search-dropdown", SearchDropdownController);

import SettingsController from "./settings_controller";
application.register("settings", SettingsController);

import SidepanelController from "./sidepanel_controller";
application.register("sidepanel", SidepanelController);

import SignupController from "./signup_controller";
application.register("signup", SignupController);

import SmsController from "./sms_controller";
application.register("sms", SmsController);

import StatusLabelsController from "./status_labels_controller";
application.register("status-labels", StatusLabelsController);

import StickyTableController from "./sticky_table_controller";
application.register("sticky-table", StickyTableController);

import SubscriptionsController from "./subscriptions_controller";
application.register("subscriptions", SubscriptionsController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import TaskController from "./task_controller";
application.register("task", TaskController);

import TemplatesController from "./templates_controller";
application.register("templates", TemplatesController);

import TextareaController from "./textarea_controller";
application.register("textarea", TextareaController);

import TileController from "./tile_controller";
application.register("tile", TileController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import UploadButtonController from "./upload_button_controller";
application.register("upload-button", UploadButtonController);

import UtilitiesController from "./utilities_controller";
application.register("utilities", UtilitiesController);

import VotesController from "./votes_controller";
application.register("votes", VotesController);

import WelcomeAiController from "./welcome_ai_controller";
application.register("welcome-ai", WelcomeAiController);

import WelcomeController from "./welcome_controller";
application.register("welcome", WelcomeController);

import ZoomController from "./zoom_controller";
application.register("zoom", ZoomController);

import ZoomPresentController from "./zoom_present_controller";
application.register("zoom-present", ZoomPresentController);
